<template>
  <section :class="{ 'details-left': showDetailsLeft }">
    <h4>
      {{ title }}
      <svg v-if="oneway">
        <use xlink:href="#icon-one-way-black"></use>
      </svg>
    </h4>
    <ul>
      <li>
        <div>
          <svg>
            <use xlink:href="#icon-center"></use>
          </svg>
        </div>
        <div>
          <p>{{ address }}</p>
        </div>
      </li>
      <li>
        <div>
          <svg>
            <use xlink:href="#icon-clock"></use>
          </svg>
        </div>
        <div>
          <p>{{ weekShift }}</p>
          <p>{{ weekEndShift }}</p>
        </div>
      </li>
    </ul>
    <ul>
      <li>
        <svg>
          <use xlink:href="#icon-phone"></use>
        </svg>
        <a
          v-if="phoneIsVisible"
          href
          @click="togglePhone()"
        >{{ $t('commons.show_phone') }}</a>
        <a
          v-else
          @click="call()"
        >{{ phone }}</a>
      </li>
      <li>
        <svg>
          <use xlink:href="#icon-email"></use>
        </svg>
        <a :href="`/contact/particulier?business_id=${business.id}`">{{ $t('components.booking.email') }}</a>
      </li>
    </ul>
    <rent-button @buttonclicked="pickAgency">
      {{ $t('components.booking.pick-agency') }}
    </rent-button>
  </section>
</template>

<script>
import RentButton from '../shared/RentButton';

export default {
  props: {
    business: {
      type: Object,
      required: true,
    },
    showDetailsLeft: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneIsVisible: true,
    };
  },
  computed: {
    title() {
      return this.business.label
    },
    oneway() {
      return this.business.is_oneway
    },
    address() {
      return this.business.address
    },
    weekShift() {
      return this.business.opening_hours.str
    },
    weekEndShift() {
      return this.business.opening_hours.weekend_str
    },
    phone() {
      return this.business.phone
    },
    url() {
      return this.business.slug
    },
  },
  components: {
    RentButton,
  },
  methods: {
    togglePhone() {
      this.phoneIsVisible = !this.phoneIsVisible;
    },
    pickAgency() {
      this.$emit('agencyselected', this.business)
    },
    call() {
      window.open(`tel:${this.phone}`);
    },
  },
};
</script>

<style scoped lang="scss">

section {
  background-color: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  left: 100%;
  padding: 20px;
  position: absolute;
  right: 0;
  right: 100%;
  top: 0;
  width: 470px;
  z-index: 9;

  .details-left {
    left: auto;
    right: 100%;
  }

  @include teq-breakpoint($wide) {
    display: flex;
    left: 100%;
    right: 0;
  }

  svg {
    max-height: 20px;
    max-width: 20px;
  }

  ul {
    &:nth-child(2) {
      display: flex;
      flex-direction: column;

      li {
        align-content: center;
        align-items: center;
        display: flex;
        flex-direction: row;
      }
    }

    &:nth-child(3) {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    li {
      margin-bottom: 10px;
    }

    li p {
      display: flex;
      line-height: 12px;
    }

    li svg {
      fill: $sunglow;
      margin-right: 8px;
    }
  }
}

h4 {
  color: $black;
  margin-bottom: 10px;
}

p {
  @include font-size(12px);

  color: $c-boulder;
  margin-bottom: 0;
}

a {
  color: $black;
  cursor: pointer;
  text-decoration: underline;
}
</style>
